import React, { Component } from 'react';
import {connect} from 'react-redux';
import {updateSearchCondition, setNotice} from '../../actions';

import {Api, Time} from '../../util';

import Loading from '../../components/loading';
import {Error, Notice} from '../../components/modal';
import FilterContainer from './FilterContainer';
import SearchContainer from './SearchContainer';
import PageContainer from './PageContainer';

class Container extends Component {
  constructor(props){
    super(props);
    this.state = {
      list: [],
      pageFrom: 0,
      activePage: 1,
      begDate: Time.getAddDate(Time.getToday(), -7), 
      endDate: Time.getAddDate(Time.getToday()),
      start: 0,
      stop: parseInt(24*3600, 10),
      keyword: '',
      priceMin: '',
      priceMax: '',
      loadingFlag: false,
      showError: false,
      errorContent: '',
      isStartDate: true,
      isCheckTime: false,

      prevPrice: 0,
      nextPrice: 0,
      prevPriceChk: false,
      nextPriceChk: false,
      isRerun: ""
    };

    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleOnStartSelect = this.handleOnStartSelect.bind(this);
    this.handleOnEndSelect = this.handleOnEndSelect.bind(this);
    this.handleOnKeywordChange = this.handleOnKeywordChange.bind(this);
    this.handleOnStartSelectTime = this.handleOnStartSelectTime.bind(this);
    this.handleOnStopSelectTime = this.handleOnStopSelectTime.bind(this);

    this.handleActivePage = this.handleActivePage.bind(this);

    this.handleHide = this.handleHide.bind(this);
    this.handleOnStartCheck = this.handleOnStartCheck.bind(this);
    this.handleOnTimeCheck = this.handleOnTimeCheck.bind(this);

    this.handleOnPrevPriceCheck= this.handleOnPrevPriceCheck.bind(this);
    this.handleOnNextPriceCheck= this.handleOnNextPriceCheck.bind(this);
    this.handlePrevOnChange = this.handlePrevOnChange.bind(this);
    this.handleNextOnChange = this.handleNextOnChange.bind(this);
    this.handleRerunYn = this.handleRerunYn.bind(this);
  }

  componentDidMount(){
    this.searchEPGES();
  }

  handleHide(){
    this.setState({
      showError: false
    })
  }
  async searchEPGES() {
    const {
      pageSize,
      chs
    } = this.props.searchCondition;
    const {
      pageFrom,
      begDate,
      endDate,
      isStartDate,
      isCheckTime,
      start,
      stop,
      keyword,
      prevPriceChk,
      nextPriceChk,
      prevPrice,
      nextPrice,
      isRerun
    } = this.state;
    let list = [], totalCount = 0, beginIndex = 0;
    if(chs.length > 0){
      try{
        this.setState({loadingFlag: true});
        const epg = await Api.SearchEpgEsWShow({
          pageFrom,
          pageSize,
          epgid: chs,
          begDate: isStartDate ? begDate : endDate,
          endDate,
          start: isCheckTime ? start : 0,
          stop: isCheckTime ? stop : parseInt(24*3600, 10),
          keyword,
          priceMin: prevPriceChk ? parseInt(prevPrice, 10) * 10000 : "",
          priceMax: nextPriceChk ? parseInt(nextPrice, 10) * 10000 : "",
          returnYn: isRerun
          
        }); 
        list = epg.files.hits;
        totalCount = epg.files.total;
        beginIndex = epg.files.from;
      } catch(e) {
        // 에러 핸들링
        this.setState({
          showError: true,
          errorContent: e
        })
      } finally {
        this.props.updateSearchCondition({
          totalCount
        });
        this.setState({
          list,
          loadingFlag: false
        });
      }
    }else{
      this.setState({
        list: 0
      });
      this.props.updateSearchCondition({
        totalCount: 0
      });
    }
  
  }
  warnInvalidValue(){
    const {prevPriceChk, nextPriceChk, prevPrice, nextPrice} = this.state;
    if(parseInt(prevPrice, 10) > parseInt(nextPrice, 10) && prevPriceChk && nextPriceChk ) this.props.setNotice(true, "fail", "가격검색 조건을 다시 입력해주세요");
    else return true;
  }
  async handleOnSubmit (){
    await this.setState({ pageFrom: 0, activePage: 1 });
    if(this.warnInvalidValue()){
      await this.searchEPGES();
    }
  }
  
  handleActivePage(activePage){
    this.setState({activePage});
  }

  handlePageChange(pageNumber){
    this.setState({
      pageFrom: pageNumber
    }, () => {
      this.searchEPGES();
    })
  }
  handleOnStartSelect(date){
    this.setState({begDate: date});
  }
  handleOnEndSelect(date){
    this.setState({endDate: date});
  }
  handleOnKeywordChange(keyword){
    this.setState({keyword});
  }
  handleOnStartSelectTime(start){
    this.setState({start});
  }
  handleOnStopSelectTime(stop){
    this.setState({stop});
  }

  handleOnStartCheck(){
    this.setState(prevState => ({isStartDate: !prevState.isStartDate}));
  }

  handleOnTimeCheck(){
    this.setState(prevState => ({isCheckTime: !prevState.isCheckTime}) );
  }

  handleOnPrevPriceCheck(){
    this.setState(prevState => ({prevPriceChk: !prevState.prevPriceChk}) );
  }
  handleOnNextPriceCheck(){
    this.setState(prevState => ({nextPriceChk: !prevState.nextPriceChk}) );
  }
  handlePrevOnChange(prevPrice){
    const value = Number(prevPrice);
    this.setState((prevState) => {
      if(prevState.prevPrice !== value && !Number.isNaN(value)){
        return {
          prevPrice: value
        }
      }
    });
  }
  handleNextOnChange(nextPrice){
    const value = Number(nextPrice);
    this.setState((prevState) => {
      if(prevState.nextPrice !== value && !Number.isNaN(value)){
        return {
          nextPrice: value
        }
      }
    });
  }
  handleRerunYn(e){
    this.setState({isRerun: e.target.value});
  }
  render() {
    const {
      display, noticeFlag
    } = this.props;

    const {
      list, 
      pageFrom,
      activePage,
      keyword,
      start,
      stop,
      loadingFlag,
      showError,
      errorContent,
      begDate,
      endDate,
      isStartDate,
      isCheckTime,

      prevPrice,
      nextPrice,
      prevPriceChk,
      nextPriceChk,
      isRerun
    } = this.state;
    const style = {display: display ? 'flex' : 'none'};

    return (
      <div className='content container search' style={style}>
      {showError ? <Error 
        handleHide={this.handleHide}
        errorContent={errorContent} /> : null}
        <FilterContainer
          keyword={keyword}
          onStart={start}
          onStop={stop}
          begDate={begDate}
          endDate={endDate}
          isStartDate={isStartDate}
          isCheckTime={isCheckTime}
          prevPrice={prevPrice}
          nextPrice={nextPrice}
          prevPriceChk={prevPriceChk}
          nextPriceChk={nextPriceChk}
          isRerun={isRerun}
          handleOnStartSelectTime={this.handleOnStartSelectTime}
          handleOnTimeCheck={this.handleOnTimeCheck}
          handleOnStopSelectTime={this.handleOnStopSelectTime}
          handleOnSubmit={this.handleOnSubmit}
          handleOnStartSelect={this.handleOnStartSelect}
          handleOnEndSelect={this.handleOnEndSelect}
          handleOnKeywordChange={this.handleOnKeywordChange}
          handleOnStartCheck={this.handleOnStartCheck}
          handleOnPrevPriceCheck={this.handleOnPrevPriceCheck}
          handleOnNextPriceCheck={this.handleOnNextPriceCheck}
          handlePrevOnChange={this.handlePrevOnChange}
          handleNextOnChange={this.handleNextOnChange}
          handleRerunYn={this.handleRerunYn}
          />
        <div className='list cover'></div>
        <SearchContainer list={list} activePage={activePage}/>
        {loadingFlag ? <Loading /> : null}
        {noticeFlag && <Notice />}
        <PageContainer 
          pageFrom={pageFrom}
          activePage={activePage}
          handleActivePage={this.handleActivePage}
          handlePageChange={this.handlePageChange}
          />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    searchCondition: state.searchCondition,
    noticeFlag: state.noticeFlag
  }
};

const mapDispatcherToProps = dispatch => {
  return {
    updateSearchCondition: (conditions) => dispatch(updateSearchCondition(conditions)),
    setNotice: (flag, state, content) => dispatch(setNotice(flag, state, content))
  }
};


Container = connect(mapStateToProps, mapDispatcherToProps)(Container);


export default Container;


// WEBPACK FOOTER //
// ./src/containers/search/index.js